import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import Spinner from './components/Spinner';

const App = lazy(() => import('./App'));

fetch('/api/config/public-config-info')
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(env => {
    window.env = env;

    ReactDOM.render(
      <Suspense fallback={<Spinner />}>
        <App />
      </Suspense>,
      document.getElementById('root') || document.createElement('div'), // `createElement` is only for testing purpose
    );
  })
  .catch(error => {
    // eslint-disable-next-line no-console
    console.error('There was a problem fetching the data:', error);
  });
